import { FC } from "react";
import { useBreakpointValue } from "@chakra-ui/react";
import times from "lodash/times";
import { SkeletonArticleCard, skeletonCardProps } from "~/features/Library";
import { ArticleCardType, calcSkeletonCardCount } from "./utils";

interface Props {
  noOfRows?: number;
  type?: ArticleCardType;
}

export const SkeletonArticleCards: FC<Props> = ({
  noOfRows = 1,
  type = "narrow",
}) => {
  const { width } = skeletonCardProps()[type];
  const formattedWidth = useBreakpointValue(width) ?? width.base;
  const count = calcSkeletonCardCount({
    width: formattedWidth,
    noOfRows,
  });

  return (
    <>
      {times(count, (i) => (
        <SkeletonArticleCard key={i} />
      ))}
    </>
  );
};
